// src/components/Navbar.js

// eslint-disable-next-line
import { ArrowRightIcon, DocumentDownloadIcon, MailIcon } from "@heroicons/react/solid";
import React from "react";

export default function Navbar() {
  const resumeUrl = process.env.PUBLIC_URL + "/Julio_Pochet_Resume.pdf";

  return (
    <header className="bg-gray-800 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0">

          <a href="#about" className="ml-3 text-xl">
            JULIO POCHET EDMEAD
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700 flex flex-wrap items-center text-base justify-center">
          <a href="#projects" className="mr-5 hover:text-white">
            Past Work
          </a>
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>
          <a href="#testimonials" className="mr-5 hover:text-white">
            Testimonials
          </a>
          <a href="#contact" className="mr-5 hover:text-white">
            Contact
          </a>
        </nav>

        <img
          src="/profile-picture.png"
          alt="Profile Picture"
          className="w-12 h-12 rounded-full"
        />

        <a
          href={resumeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0"
        >
          Download My Resume
          <DocumentDownloadIcon className="w-4 h-4 ml-1" />
        </a>

      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js